import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Tooltip,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ImageGallery from '../../gallery/index';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import timeZoneOptions from '../../../../../../data/timeZone';
import currencies from '../../../../../../data/currencies';
import country from '../../../../../../data/country';
import timeZoneList from '../../../../../../data/timeZoneList';
import currencyList from '../../../../../../data/currencyList';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Select from 'react-select';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { reactSelectOptionDiffrentPro } from '../../../../../../helpers/Utils';
import moment from 'moment';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { htmlEditButton } from 'quill-html-edit-button';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
  gAPI_Internal_Property_By_Id,
  postAPI_Update_Property,
  gAPI_QuestionOptionList,
} from '../../../../../../constants/APIs';
Quill.register('modules/htmlEditButton', htmlEditButton);
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
  htmlEditButton: {},
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
];
export default function PropertyForm({
  visible,
  toggle,
  propertyId,
  LoadData,
}) {
  const groupId = getGroupID();
  const [selectedCountry, setSelectedCountry] = useState({
    value: '',
    label: 'Please Select',
  });
  const [selectZones, setSelectZones] = useState();
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [propertyData, setPropertyData] = useState({
    type: 'hotel',
    name: '',
    currency: 'NZD',
    timeZone: 'None',
    country: 'NZ',
    websiteLink: '',
    images: 'https://via.placeholder.com/150/',
    bedrooms: 0,
    baths: 0,
    guests: 0,
    description: '',
    address: '',
    searchTags: [],
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (propertyId !== undefined && propertyId !== '-1') {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${groupId}`,
      })
        .then((res) => {
          const dataBody = {
            type: res.data.type,
            name: res.data.name,
            timeZone: res.data.timeZone,
            country: res.data.country,
            currency: res.data.currency,
            websiteLink: res.data.websiteLink,
            images:
              res.data.images === ''
                ? 'https://via.placeholder.com/150/'
                : res.data.images,
            bedrooms: res.data.bedrooms,
            baths: res.data.baths,
            guests: res.data.guests,
            description: res.data.description,
            address: res.data.address,
            searchTags: res.data.searchTags,
          };
          setPropertyData(dataBody);
          AxiosAPI({
            method: 'get',
            url: `${gAPI_QuestionOptionList}?propertyId=-1&groupId=${getGroupID()}&type=Property`,
          })
            .then((res) => {
              var options = [];
              try {
                res.data.map((item) =>
                  options.push({
                    label: item.option,
                    value: item.option,
                    key: item.id,
                  })
                );
              } finally {
              }
              setTags(options);
              var selectedTags = [];
              try {
                if (
                  dataBody.searchTags !== null &&
                  dataBody.searchTags.length > 0
                ) {
                  dataBody.searchTags.map((item) =>
                    selectedTags.push(
                      options.filter((cat) => cat.value === item)[0]
                    )
                  );
                }
              } finally {
              }
              setselectedTags(selectedTags);
            })
            .catch((err) => console.log('err', err));
          let timeZones = timeZoneList.filter(
            (item) => item.IsoAlpha2 === res.data.country
          );
          const countryGroup = country.filter(
            (item) => item.code === res.data.country
          );
          let countrySelected = {
            value: countryGroup[0].code,
            label: countryGroup[0].name,
          };
          setSelectedCountry(countrySelected);
          setSelectZones(
            timeZones[0].TimeZones.map((zone, index) => {
              return (
                <option value={zone} key={index}>
                  {zone}
                </option>
              );
            })
          );
        })
        .catch((err) => console.log('err', err));
    }
  }, [propertyId]);
  const handleChange = (e) => {
    setPropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
  };

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    setPropertyData({
      ...propertyData,
      images: image.src,
    });
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleChangeSelect = (value) => {
    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    setPropertyData({
      ...propertyData,
      country: value.value,
      currency: currency[0].currencyCode,
      timeZone: timeZones[0].TimeZones[0],
    });
    setSelectedCountry(value);
    setSelectZones(
      timeZones[0].TimeZones.map((zone) => {
        return <option value={zone}>{zone}</option>;
      })
    );
  };

  const handleSubmit = () => {
    const formmatedData = { ...propertyData, updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_Property}/about-property/${propertyId}`,
      data: formmatedData,
    }).then(() => {
      NotificationManager.success(
        '',
        'Profile update successfully',
        3000,
        null,
        null,
        'success'
      );
      LoadData();
      toggle();
    });
  };

  const selectTimeZoneOptions = timeZoneOptions
    .sort(dynamicSort('label'))
    .map((item) => {
      return <option value={item.value}>{item.label}</option>;
    });

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const handleDescriptionChange = (e) => {
    if (propertyData.name !== '') {
      setPropertyData({
        ...propertyData,
        description: e.target.value,
      });
    }
  };
  const handleChangeTags = (selectedTags) => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags.map((elem) => elem.value);

    setPropertyData({
      ...propertyData,
      searchTags: tagsArr,
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Bussiness Profile</ModalHeader>
        <ModalBody>
          <Row className="">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>
                    Bussiness Name{' '}
                    <i className="demo-icon simple-icon-info" id="titletip"></i>
                  </Label>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="titletip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                  >
                    A short title which will appear when users ask about the
                    bussiness profile
                  </Tooltip>
                  <Input
                    type="text"
                    value={propertyData.name}
                    onChange={(e) => handleChange(e)}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Bussiness Website</Label>
                  <Input
                    type="text"
                    defaultValue={propertyData.websiteLink}
                    onChange={(e) => handleChange(e)}
                    name="websiteLink"
                  />
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <Label>Bussiness Type</Label>
                  <Input
                    type="select"
                    value={propertyData.type}
                    name="type"
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="ActivityProvider">Activity Provider</option>
                    <option value="CampGround">CampGround</option>
                    <option value="HolidayHome">Holiday Home</option>
                    <option value="Hostel">Hostel</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Lodge">Lodge</option>
                    <option value="Motel">Motel</option>
                    <option value="Bach">Other Business Operator</option>
                    <option value="Pub">Pub</option>
                    <option value="Resort">Resort</option>

                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Country</Label>
                  <Select
                    isMulti={false}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="code"
                    placeholder="Select Country"
                    onChange={handleChangeSelect}
                    value={selectedCountry}
                    options={
                      country
                        ? reactSelectOptionDiffrentPro(
                          country,
                          true,
                          'code',
                          'name',
                          ''
                        )
                        : []
                    }
                  />
                </Colxx>
                {selectZones !== undefined && selectZones.length > 0 && (
                  <Colxx sm={6} className="mb-3">
                    <Label>Time Zone</Label>
                    <Input
                      type="select"
                      value={propertyData.timeZone}
                      name="timeZone"
                      onChange={(e) => handleChange(e)}
                    >
                      {selectZones}
                    </Input>
                  </Colxx>
                )}
                <Colxx sm={12} className="mb-3">
                  <Label>Address</Label>
                  <Input
                    type="textarea"
                    defaultValue={propertyData.address}
                    name="address"
                    onChange={(e) => handleChange(e)}
                  ></Input>
                </Colxx>
                {propertyData.type === 'HolidayHome' && (
                  <Fragment>
                    <Colxx sm={4} className="mb-3">
                      <Label>Bed Rooms (for Holiday Homes)</Label>
                      <Input
                        type="number"
                        name="bedrooms"
                        min={0}
                        value={propertyData.bedrooms}
                        onChange={(e) => handleChange(e)}
                      />
                    </Colxx>
                    <Colxx sm={4} className="mb-3">
                      <Label>Baths (for Holiday Homes)</Label>
                      <Input
                        type="number"
                        name="baths"
                        min={0}
                        value={propertyData.baths}
                        onChange={(e) => handleChange(e)}
                      />
                    </Colxx>
                    <Colxx sm={4} className="mb-3">
                      <Label>Guests (for Holiday Homes)</Label>
                      <Input
                        type="number"
                        name="guests"
                        min={0}
                        value={propertyData.guests}
                        onChange={(e) => handleChange(e)}
                      />
                    </Colxx>
                  </Fragment>
                )}
                <Colxx sm={12}>
                  <FormGroup>
                    <Label for="bookingUrl">Search Tags</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedTags}
                      onChange={handleChangeTags}
                      options={tags}
                    />
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>

            <Colxx sm={12} className="mb-3">
              <Label className="mt-3">Details</Label>
              <Input
                type="textarea"
                name="description"
                onChange={(e) => handleDescriptionChange(e)}
                placeholder="Description"
                value={propertyData.description}
                rows={10}
              />
              {/* <ReactQuill
                theme="snow"
                value={propertyData.description}
                onChange={(content, delta, source) => {
                  handleDescriptionChange(source, content);
                }}
                modules={quillModules}
                formats={quillFormats}
                name="description"
              /> */}
            </Colxx>

            <Fragment>
              <Colxx sm={12}>
                <h4>Logo</h4>
              </Colxx>
              <Colxx sm={12}>
                <Row>
                  <Colxx sm={2} className="md-3">
                    <img
                      style={{
                        width: '100%',
                        height: '90%',
                      }}
                      alt="room image"
                      src={
                        propertyData.images ||
                        'https://via.placeholder.com/150/'
                      }
                    />
                  </Colxx>
                  <Colxx sm={1} className="mb-3">
                    <Label>Browse</Label>
                    <div
                      className="iconsminds-photo"
                      onClick={(event) => togglegallery()}
                      style={{
                        cursor: 'pointer',
                        fontSize: '28px',
                        color: '#73236b',
                      }}
                    ></div>
                  </Colxx>
                </Row>
              </Colxx>
            </Fragment>
          </Row>
          {ImageGalleryButton()}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            <IntlMessages id='dashboards.save' />
          </Button>
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id='pages.cancel' />
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
